import './form.scss';
// import CellDatepicker from '../CellDatepicker/CellDatepicker';
import CellInputMask from '../NCellInputMask/CellInputMask';
import ParamRadioButton from '../NParamRadioButton/ParamRadioButton';
import CellSelect from '../NCellSelect/CellSelect';
import ParamCheckbox from '../NParamCheckbox/ParamCheckbox';
import CellFias from '../NCellFias/CellFias';
import CellDataPicker from '../NCellDatepicker/CellDatepicker';
import CellTextarea from '../NCellTextarea';
import RadioButton from '../NRadioButton';
// import MultiDate from '../MultiDate';
import CellInput from '../NCellInput';
import { dropdownDown, dropdownUp } from '../../../utils/utils';
import Checkbox from '../NCheckbox';
import Loader from '../NLoader';

export default class Form {
	constructor(form, submitForm) {
		this.$form = form;
		this.$formButton = this.$form.querySelector('.js-form-button');
		this.$formError = this.$form.querySelector('.js-form-error');
		this.isFormErrorVisible = false;
		this.formElements = {};
		this.formAction = submitForm;

		this.init();
	}

	init() {
		this.$form.addEventListener('submit', this.onSubmitForm.bind(this));
		this.$formButton.addEventListener('click', this.onSubmitForm.bind(this));
	}

	onSubmitForm(e) {
		e.preventDefault();
		const externalErrors = this.isExternalErrors ? this.isExternalErrors() : false;

        if (!externalErrors) {
            this.normalizeValues();
            //Если ошибок нет, вызываем функцию отправки формы
            if (!this.checkForm(true)) {
                this.formAction ? this.formAction(e) : null;
            } else {
                this.scrollToErrorField();
            }
        }
    }

	checkForm(showError = false) {
		let errorForm = false;
		Object.values(this.formElements).forEach(($Element) => {
			if ($Element.isInputError(showError)) {
				errorForm = true;
			}
		});

		return errorForm;
	}

	blockingFormButton() {
		this.$formButton.classList.add('disabled');
	}

	unblockingFormButton() {
		this.$formButton.classList.remove('disabled');
	}

	showFormError(message) {
		this.isFormErrorVisible = true;
		message && (this.$formError.textContent = message);
		dropdownDown(this.$formError);
	}

	hideFormError() {
		this.isFormErrorVisible = false;
		dropdownUp(this.$formError);
	}

	normalizeValues() {
		Object.values(this.formElements).forEach(($Element) => {
			const attr = $Element.$cell.getAttribute('data-class');
			if (attr === 'CellInput' || attr === 'CellInputMask' || attr === 'CellTextarea') {
				$Element.normalizeValue();
			}
		});
	}

	scrollToErrorField() {
		const errorFields = document.querySelectorAll('.js-cell-error');
		errorFields[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
	}

	getFormData() {
		let formData = new FormData();

		Object.keys(this.formElements).forEach((key) => {
			if (typeof this.formElements[key].currentValue === 'object') {
				this.formElements[key].currentValue.forEach((item) => {
					formData.append(key, item);
				});
			} else {
				formData.append(key, this.formElements[key].currentValue);
			}
		});

		return formData;
	}

	addFormElement($el, options) {
		const elName = $el.getAttribute('data-name');
		const elClassName = $el.getAttribute('data-class');

		switch (elClassName) {
			case 'CellInput':
				this.formElements[elName] = new CellInput($el, options);
				break;
			case 'CellInputMask':
				this.formElements[elName] = new CellInputMask($el, options);
				break;
			// case 'CellDatepicker':
			//     this.formElements[elName] = new CellDatepicker($el, options);
			//     break;
			case 'CellSelect':
				this.formElements[elName] = new CellSelect($el, options);
				break;
			case 'CellFias':
				this.formElements[elName] = new CellFias($el, options);
				break;
			case 'CellDatepicker':
				this.formElements[elName] = new CellDataPicker($el, options);
				break;
			case 'CellTextarea':
				this.formElements[elName] = new CellTextarea($el, options);
				break;
			case 'Checkbox':
				this.formElements[elName] = new Checkbox($el, options);
				break;
			case 'RadioButton':
				this.formElements[elName] = new RadioButton($el, options);
				break;
			case 'ParamCheckbox':
				this.formElements[elName] = new ParamCheckbox($el, options);
				break;
			case 'ParamRadioButton':
				this.formElements[elName] = new ParamRadioButton($el, options);
				break;
			// case 'MultiDate':
			//     this.formElements[elName] = new MultiDate($el, options);
			//     break;
			case 'Loader':
				this.formElements[elName] = new Loader($el, options);
				break;
			default:
				console.error('Unknown class');
				break;
		}
	}

	compareDates(date1, date2) {

		var separatedDate1 = date1.split('.');
		var birthDate = new Date(separatedDate1[2], separatedDate1[1] - 1, separatedDate1[0]);


		birthDate.setFullYear(birthDate.getFullYear() + 14);

		var separatedDate2 = date2.split('.');
		var issuedDate = new Date(separatedDate2[2], separatedDate2[1] - 1, separatedDate2[0]);

		return birthDate <= issuedDate;
	}

	clearForm() {

		if (typeof this.$form.reset === 'function') {
			this.$form.reset();
		}


		Object.values(this.formElements).forEach(($Element) => {
			if (typeof $Element.clearValue === 'function') {
				$Element.clearValue();
			} else {
				$Element.currentValue = '';
			}
		});

		if (this.isFormErrorVisible) {
			this.hideFormError();
		}
	}
}
